import Container from './StorageCapacity.container';
import StorageCapacity from './StorageCapacity';

export default Container(StorageCapacity);
